<div class="flex flex-auto flex-col items-center justify-center p-12">
  <img src="../../../assets/no-scans.png" class="w-[260px]" />
  <div class="text-lg font-semibold mt-6">No Data</div>
  <div class="text-center text-sm mt-2">{{ reason() }}</div>
</div>
